import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import sunbitApi from '../services/sunbitApi';
import CommonThunk from '../models/CommonThunk';
import DocumentTypes, { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import IDocument from '@sunbit-dev/common/models/IDocument';

export enum ActionTypes {
  LoadStaticDocument = 'LoadStaticDocument',
}

const loadStaticDocumentPending = () => ({
  type: ActionTypes.LoadStaticDocument,
  status: ActionStatus.Pending
});

const loadStaticDocumentSuccess = (document: IDocument) => ({
  type: ActionTypes.LoadStaticDocument,
  status: ActionStatus.Success,
  ...document
});

const loadStaticDocumentFailure = (error: ApplicationError) => ({
  type: ActionTypes.LoadStaticDocument,
  status: ActionStatus.Failure,
  error
});

export const loadStaticDocumentThunk = (document: string):CommonThunk => {
  return async (dispatch) => {
    dispatch(loadStaticDocumentPending());
    try {
      const documentResponse = await sunbitApi.getStaticDocument(DocumentTypes[document as DocumentTypesTypes]);
      dispatch(loadStaticDocumentSuccess(documentResponse));
    } catch (error) {
      dispatch(loadStaticDocumentFailure(error as ApplicationError));
    }
  }
}

export type Actions =
  ReturnType<typeof loadStaticDocumentPending> |
  ReturnType<typeof loadStaticDocumentSuccess> |
  ReturnType<typeof loadStaticDocumentFailure>
;
